import UserAgentRoute from './UserAgent'
import ClassFeedbackRoute from './ClassFeedback'
import ForceLoginRoute from './ForceLogin'
import ClassWaitingRoute from './ClassWaiting'

const SinglePage = (store) => ([
  UserAgentRoute(store),
  ClassFeedbackRoute(store),
  ForceLoginRoute(store),
  ClassWaitingRoute(store),
])

export default SinglePage